module.exports = __webpack_public_path__ + "media/images/mstile-70x70-1708a97e36f4b3abc8279357377662a6.png";